export const config = {
  appId: process.env.REACT_APP_ID || '',
  authority: process.env.REACT_APP_AUTHORITY || '',
  redirectUri: process.env.REACT_APP_REDIRECT_URI || '',
  scopes: [
    'user.read',
  ]
};
